export default __webpack_public_path__ + "motor.png?5e5c3814c19ccf82ffeb667401067506";